<div class="schedule-details" *ngIf="schedule">
    <table mat-table [dataSource]="schedule.payments" class="layout-grid"
        [class.schedule-details__table--with-fees]="schedule.showFees"
        [attr.aria-labelledby]="ariaLabelledBy">
        <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef
                class="grid-column-multiline">Date</th>
            <td mat-cell *matCellDef="let payment"
                class="grid-column-multiline">
                <div class="schedule-details__date">
                    {{ payment.date | scheduledDate }}
                </div>
                <div *ngIf="payment.status"
                    class="schedule-details__status">
                    {{ payment.status | sentencecase }}
                </div>
            </td>
            <td mat-footer-cell *matFooterCellDef>
                <strong>Totals</strong>
            </td>
        </ng-container>

        <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>Amount</th>
            <td mat-cell *matCellDef="let payment"
                [attr.data-amount-marker]="payment.amountMarker || null">{{ payment.amount | currency:'USD':'symbol':'1.2-2' }}</td>
            <td mat-footer-cell *matFooterCellDef>
                <strong>{{ schedule.totalScheduledAmount | currency:'USD':'symbol':'1.2-2' }}</strong>
            </td>
        </ng-container>

        <ng-container matColumnDef="fee">
            <th mat-header-cell *matHeaderCellDef>Fee<!-- TODO (TOP-3034): Restore when estimate display is configurable: {{ schedule.feesAreEstimates ? ' *' : '' }} --></th>
            <td mat-cell *matCellDef="let payment">{{ (payment.fee ?? 0) | currency:'USD':'symbol':'1.2-2' }}</td>
            <td mat-footer-cell *matFooterCellDef>
                <strong>{{ (schedule.totalFees ?? 0) | currency:'USD':'symbol':'1.2-2' }}</strong>
            </td>
        </ng-container>

        <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef>Total</th>
            <td mat-cell *matCellDef="let payment">{{ (payment.total ?? payment.amount) | currency:'USD':'symbol':'1.2-2' }}</td>
            <td mat-footer-cell *matFooterCellDef>
                <strong>{{ (schedule.grandTotal ?? schedule.totalScheduledAmount) | currency:'USD':'symbol':'1.2-2' }}</strong>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let payment; columns: displayedColumns;"
            [class.pending-row]="isPendingPayment(payment)"
            [class.selected-row]="isSelectedPayment(payment)"
            [class.clickable-row]="isClickable(payment)"
            [attr.aria-current]="isSelectedPayment(payment) ? 'true' : null"
            (pointerdown)="onPointerdown_row(payment, $event)"></tr>
        <tr mat-footer-row
            *matFooterRowDef="displayedColumns"></tr>
    </table>

    <p class="schedule-details__footnote"
        *ngIf="hasAdjustedFinalPayment">
        ** Final payment adjusted to match the remaining
        balance.
    </p>

    <!-- TODO (TOP-3034): Restore when estimate display is configurable
    <p class="schedule-details__footnote"
        *ngIf="schedule.feesAreEstimates">
        * Fees are estimates and may vary slightly at time of
        processing.
    </p>
    -->

    <mat-list *ngIf="schedule.originalBalanceDue !== undefined && schedule.originalBalanceDue !== null">
        <mat-list-item>
            <strong>Total Amount Scheduled:</strong>
            <span>{{ schedule.totalScheduledAmount | currency:'USD':'symbol':'1.2-2' }}</span>
        </mat-list-item>

        <mat-list-item>
            <strong>Balance Due (at time of scheduling):</strong>
            <span>{{ schedule.originalBalanceDue | currency:'USD':'symbol':'1.2-2' }}</span>
        </mat-list-item>

        <mat-list-item>
            <strong>Total Amount Paid:</strong>
            <span>{{ schedule.totalAmountPaid | currency:'USD':'symbol':'1.2-2' }}</span>
        </mat-list-item>

        <mat-list-item>
            <strong>Balance Remaining:</strong>
            <span>{{ schedule.balanceRemaining | currency:'USD':'symbol':'1.2-2' }}</span>
        </mat-list-item>
    </mat-list>
</div>
